'use client'

import { MobileFooter, DesktopFooter } from '@quark/footer'
import { parseFooterData } from '@utils/quarkFooterUtils'
import { getClassNames } from '@helpers/productWidgetHelper'
import styles from './footer.module.scss'

export const Footer = ({
  data,
  addBottomPadding,
  homePage = false,
}: {
  data: any
  addBottomPadding?: boolean
  homePage?: boolean
}) => {
  if (!data) return null
  const parsedFooterData = parseFooterData(data, homePage)
  return (
    <>
      <div className={getClassNames([styles.mobileFooter], { [styles.bottomPadding]: !!addBottomPadding })}>
        <MobileFooter footerData={parsedFooterData} />
      </div>
      <div className={getClassNames([styles.desktopFooter], { [styles.bottomPadding]: !!addBottomPadding })}>
        <DesktopFooter footerData={parsedFooterData} />
      </div>
    </>
  )
}
